import * as React from "react";
function SvgUserArrowDown(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
        d="M29 25l-4 4-4-4M25 19v8"
      />
      <circle
        cx={14}
        cy={10}
        r={7}
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M9.11 29H3a11 11 0 0118.54-8"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgUserArrowDown);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
